import {
  Card, CardContent, CardHeader, Divider, List, ListItem, ListItemAvatar, ListItemText, Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  root: {},
  content: {
    padding: 0
  },
  listItem: {
    cursor: 'pointer'
  },
  inner: {
    minWidth: 1150
  },
  methodCell: {
    width: 100
  },
  statusCell: {
    width: 64
  },
  baslik: {
    padding: theme.spacing(1)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

function Notes() {
  const classes = useStyles();
  const { t } = useTranslation('overview');
  const [notesList, setNotesList] = useState([]);
  const workOrderInformation = useSelector((state) => state.workOrderDetail.WorkOrderInformation);


  useEffect(() => {
    if (workOrderInformation?.length > 0) {
      const value = workOrderInformation.slice();
      setNotesList(value[0].WorkOrderComments);
    }
  }, [workOrderInformation]);

  return (
    <div>
      <Card>
        <CardHeader title={t('lblNotes')} />
        <Divider />
        <CardContent className={classes.content}>
          <List className={classes.root}>
            {notesList.map((log) => (
              <div key={log.WorkOrderId} className={classes.listItem}>
                <ListItem alignItems="flex-start">
                  <ListItemText
                    primary={log.Issue}
                    secondary={(
                      <>
                        <br />
                        {t('SN')}
                        :
                        {log.Dsc}
                        <br />
                        {t('lblActive')}
                        :
                        {log.Active.toString()}
                        <br />
                        {t('lblType')}
                        :
                        {log.Type}
                      </>
                    )}
                  />
                </ListItem>
                <Divider variant="inset" component="li" />
              </div>
            ))}
          </List>
        </CardContent>
      </Card>
    </div>
  );
}


export default Notes;
